/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteOwnerResponse } from '../../models/delete-owner-response';

export interface DeleteOwner$Params {

/**
 * ID of the user to delete
 */
  userId: string;

/**
 * ID of the organization the user belongs to
 */
  orgId: string;
}

export function deleteOwner(http: HttpClient, rootUrl: string, params: DeleteOwner$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteOwnerResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteOwner.PATH, 'delete');
  if (params) {
    rb.path('userId', params.userId, {});
    rb.path('orgId', params.orgId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteOwnerResponse>;
    })
  );
}

deleteOwner.PATH = '/api/v2/owner/{userId}/organization/{orgId}';
